import { useReducer } from 'react';

/** Returns a value that can be used as a key and a function to imperatively bump the key */
export function useRerender(): [number, () => void] {
  return useReducer((prev) => prev + 1, 0);
}
